import { render } from "./slideroot-3.vue?vue&type=template&id=37340950&scoped=true"
import script from "./slideroot-3.vue?vue&type=script&lang=js"
export * from "./slideroot-3.vue?vue&type=script&lang=js"

import "./slideroot-3.vue?vue&type=style&index=0&id=37340950&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37340950"]])

export default __exports__